import React, { lazy, Suspense, useState } from "react";
import { useRenderQuotePdf } from "../../../hooks/useRenderQuotePdf";
import { QuotePdfProps } from "../PdfGenerator";
import { Dialog, DialogContent, DialogTrigger } from "../../../mp/components/Dialog";
import Loading from "../../loading/Loading";

const PdfViewer = lazy(() => import('../PdfViewer'));

export default function QuotePdfPreview<E extends HTMLElement>({ quote, children, rootRef, noTrigger }: { quote?: QuotePdfProps | null, children: React.ReactNode, rootRef?: React.RefObject<E>, noTrigger?: boolean }) {
  const [isPdfPreviewOpen, setIsPdfPreviewOpen] = useState(false);
  const { loading: quotePdfLoading, url: quotePdfUrl } =
    useRenderQuotePdf(quote);
  return (
    <Dialog open={isPdfPreviewOpen} onOpenChange={setIsPdfPreviewOpen}>
      {noTrigger ? children : (
        <DialogTrigger asChild>
          {children}
        </DialogTrigger>
      )}
      <DialogContent
        root={rootRef}
        className='pdf-preview-dialog-content'
        overlayProps={{
          className: 'pdf-preview-dialog-overlay',
        }}
      >
        {quotePdfUrl ? (
          <Suspense fallback={<Loading />}>
            <PdfViewer
              url={quotePdfUrl}
              onClickOutside={() => setIsPdfPreviewOpen(false)}
            />
          </Suspense>
        ) : quotePdfLoading ? (
          <Loading />
        ) : null}
      </DialogContent>
    </Dialog>
  )
}

